import { fonts } from '../../../themes/base/fonts';
import { grayPalette, royalBluePalette } from '../../../themes/colors';

export const textDarkV2Theme = {
  font: {
    code: fonts.code,
  },
  code: {
    backgroundColor: grayPalette[1000],
    borderColor: `1px solid ${grayPalette[600]}`,
  },
  color: {
    primary: grayPalette[0],
    contrast: grayPalette[1000],
    faded: grayPalette[200],
    dark: royalBluePalette[100],
    description: grayPalette[200],
  },
};
